<mat-card class="card-base-section">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header-title"
      >Workspace Settings</mat-card-title
    >
  </mat-card-header>
  <p class="description">
    Manage the workspace details and administrative controls for this project.
  </p>
  <div class="card-header-division"></div>

  <div class="flex-it flex-row flex-xcontent-center">
    <button
      mat-stroked-button
      color="warn"
      [disabled]="
        !workspace || (workspace.owner !== userID && !isPlatformAdmin)
      "
      (click)="delete()"
    >
      Delete Workspace
    </button>
    <div class="message">
      @if (isPlatformAdmin && workspace?.owner !== userID) {
        <i>You are deleting this workspace as a platform admin.</i>
      } @else {
        <i>Only the workspace owner may delete a workspace.</i>
      }
    </div>
  </div>
</mat-card>
